/**
 * Combined PCC Q&A set (Wave 1 + Wave 2), de-duplicated by slug.
 * All /pcc question surfaces (hub, /pcc/q/$slug, JSONL feed, sitemap)
 * read from here so a new wave lands everywhere at once.
 */
import { PCC_QA, type PccQA } from "./questions-500";
import { PCC_QA_WAVE2 } from "./questions-wave2";
import { PCC_QA_WAVE3 } from "./questions-wave3";
import { PCC_QA_WAVE4 } from "./questions-wave4";
import { liftToFloor } from "../_qa/topup-merge";
import { PCC_TOPUP_AXIS } from "../_qa/topup-axes";

const merged: PccQA[] = [];
const seen = new Set<string>();
for (const qa of [...PCC_QA, ...PCC_QA_WAVE2, ...PCC_QA_WAVE3, ...PCC_QA_WAVE4]) {
  if (seen.has(qa.slug)) continue;
  seen.add(qa.slug);
  merged.push(qa);
}

liftToFloor<PccQA["cluster"], PccQA>(merged, {
  prefix: "pcc-t7",
  asOf: "ข้อมูลทบทวน ณ สิงหาคม 2569 แบบฟอร์ม ช่องทางยื่น และระยะเวลาพิจารณาเปลี่ยนได้ ควรยืนยันกับหน่วยงานก่อนยื่น เว็บไซต์ไม่แสดงค่าบริการ ขอใบเสนอราคาเฉพาะเคสได้ทางโทรศัพท์ LINE หรืออีเมล",
  authorityTh: "กองทะเบียนประวัติอาชญากร สำนักงานตำรวจแห่งชาติ และหน่วยงานปลายทาง",
  clusterTh: "งานขอใบตรวจประวัติอาชญากรรม",
  primary: PCC_TOPUP_AXIS,
  clusters: { documents: "documents", process: "process", risk: "legal", location: "location" },
});

export const PCC_QA_ALL: PccQA[] = merged;

export const PCC_QA_ALL_BY_SLUG: Record<string, PccQA> = Object.fromEntries(
  PCC_QA_ALL.map((q) => [q.slug, q]),
);

/** Total distinct phrasings covered (question + synonym clusters). */
export const PCC_QA_PHRASING_COUNT = PCC_QA_ALL.reduce(
  (n, qa) => n + 1 + qa.synonyms.length,
  0,
);
